import "./App.css";
import { useModal } from "./context/ModalBalanceContext";
import { ModalProvider } from "./context/ModalContext";
import AppRoutes from "./routes/AppRoutes";

import { BrowserRouter } from "react-router-dom";
import { ModalBalance } from "./components/ModalBalance/ModalBalance";
import { useEffect } from "react";
import { useSelector } from "react-redux";

function App() {
  const { isModalBalanceVisible, setIsModalBalanceVisible } = useModal();
  const user = useSelector((state) => state?.user?.data);
  const isAuth = useSelector((state) => state?.user?.isLogin);

  useEffect(() => {
    if (
      user?.billing?.ballance === 0 &&
      isAuth &&
      user?.billing?.tariffId === "7ecaf94d-9ba5-4ec3-bef6-66d43132c19a"
    ) {
      setIsModalBalanceVisible(true);
    }
  }, [
    user?.billing?.ballance,
    isAuth,
    user?.billing?.tariffId,
    setIsModalBalanceVisible,
  ]);

  return (
    <div className="App">
      <BrowserRouter>
        <ModalProvider>
          <AppRoutes />
          {isModalBalanceVisible && (
            <ModalBalance
              visible={isModalBalanceVisible}
              setVisible={setIsModalBalanceVisible}
            />
          )}
        </ModalProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
